import React from "react";
import '../styles/carga.css';

export default function Load(){
    return(
        <div className="preloader"></div>
    );
}